var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCiIntegration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_6368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.762 19.8094C17.8663 19.8094 19.5721 18.1036 19.5721 15.9994C19.5721 13.8952 17.8663 12.1894 15.762 12.1894C13.6578 12.1894 11.952 13.8952 11.952 15.9994C11.952 18.1036 13.6578 19.8094 15.762 19.8094Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.762 9.15455e-05C8.30668 9.15455e-05 2.04317 5.09966 0.266551 11.9996C0.249959 12.0615 0.241055 12.1253 0.240036 12.1894C0.240036 12.6081 0.580565 12.9514 1.00204 12.9514H7.45396C7.6 12.9519 7.74304 12.9099 7.86568 12.8307C7.98832 12.7514 8.08529 12.6382 8.14479 12.5048C8.14479 12.5048 8.15456 12.4866 8.15874 12.4769C9.48876 9.60749 12.393 7.61595 15.7648 7.61595C20.3941 7.61595 24.1469 11.3674 24.1469 15.9966C24.1469 20.6259 20.3955 24.3773 15.7662 24.3773C12.3958 24.3773 9.49155 22.3857 8.16014 19.5163C8.15595 19.5066 8.14618 19.4884 8.14618 19.4884C8.02337 19.2177 7.75262 19.0418 7.45536 19.0418H1.00343C0.58196 19.0418 0.241431 19.3824 0.241431 19.8038C0.242157 19.868 0.251066 19.9318 0.267946 19.9936C2.04456 26.8936 8.30947 31.9931 15.7634 31.9931C24.6005 31.9917 31.7767 24.8294 31.7767 15.9938C31.7767 7.15819 24.613 -0.00549316 15.7774 -0.00549316L15.762 9.15455e-05Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_6368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCiIntegration);
export default __webpack_public_path__ + "static/media/circle-ci-integration.8401fd547213ce7694c33f33b5edb81a.svg";
export { ForwardRef as ReactComponent };